import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loadLogsAsync } from "../../../../actions/restaurantDetails";
import RestaurantPPETAUpdated from "./components/restaurantPPETAUpdated";
import Pagination from "../../../../components/pagination";
import queryString from "query-string";
import Loader from "../../../../components/loader";
import PropTypes from "prop-types";

class RestaurantLogs extends React.Component {
  componentDidMount() {
    this.props.loadLogsAsync({
      id: this.props.id,
      page: this.props.page,
      itemsPerPage: this.props.itemsPerPage,
      user: this.props.user,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.page !== this.props.page || prevProps.id !== this.props.id) {
      this.props.loadLogsAsync({
        id: this.props.id,
        page: this.props.page,
        itemsPerPage: this.props.itemsPerPage,
        user: this.props.user,
      });
    }
  }

  render() {
    let RenderLog = (item) => {
      switch (item.eventType) {
        case "RestaurantPPETAUpdated":
          return <RestaurantPPETAUpdated item={item} key={item.id} />;
        default:
          return;
      }
    };

    if (this.props.isLoading) return <Loader />;

    return (
      <div className="row">
        <div className="col-md-12">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th className="w15">Type</th>
                <th className="w50">Event</th>
                <th className="w20">At</th>
                <th className="w15">By</th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.map((item, index) => {
                return RenderLog(item);
              })}
            </tbody>
          </table>
          <Pagination url={"/restaurants/" + this.props.id + "/logs"} totalItems={this.props.totalItems} page={this.props.page} itemsPerPage={this.props.itemsPerPage} />
        </div>
      </div>
    );
  }
}

RestaurantLogs.propTypes = {
  id: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    eventType: PropTypes.string
  })),
  page: PropTypes.number,
  itemsPerPage: PropTypes.number,
  totalItems: PropTypes.number,
  isLoading: PropTypes.bool,
  user: PropTypes.object,
  loadLogsAsync: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
  let currentPage = queryString.parse(state.router.location.search).page ? parseInt(queryString.parse(state.router.location.search).page, 10) : 1;
  return {
    id: props.id,
    data: state.restaurantDetails.logs.data,
    page: currentPage,
    itemsPerPage: state.restaurantDetails.logs.itemsPerPage,
    totalItems: state.restaurantDetails.logs.totalItems,
    isLoading: state.restaurantDetails.logs.isLoading,
    user: state.oidc.user,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadLogsAsync,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantLogs);



// WEBPACK FOOTER //
// ./src/containers/restaurants/details/logs/index.js